'use client';

import { c as _c } from "react/compiler-runtime";
import { SvgAdd, SvgMyFill, SvgShoppingBasketFill, SvgStore } from '@common/icon';
import { cn } from '@core/utils';
import { usePathname } from 'next/navigation';
import { useState } from 'react';
import { CustomLink } from '@/app/_components/CustomLink';
import { ServiceSwitchDropdown } from '@/app/_components/ServiceSwitchDropdown';
import { ROUTES, WEL_MARKET_ROUTES } from '@/constants';
import { useAdpopcorn } from '@/modules/adpopcorn';
const ANIMATION_DURATION = 300;
type LocalMarketBnbLinkItem = {
  kind: 'link';
  label: string;
  route: {
    pathname: string;
  };
  icon: typeof SvgStore;
};
type LocalMarketBnbAdpopcornItem = {
  kind: 'adpopcorn';
  label: '혜택';
};
type LocalMarketBnbItem = LocalMarketBnbLinkItem | LocalMarketBnbAdpopcornItem;
const LOCAL_MARKET_BNB_ITEMS: readonly LocalMarketBnbItem[] = [{
  kind: 'link',
  label: '홈',
  route: WEL_MARKET_ROUTES.HOME,
  icon: SvgStore
}, {
  kind: 'link',
  label: '장바구니',
  route: WEL_MARKET_ROUTES.CART,
  icon: SvgShoppingBasketFill
}, {
  kind: 'adpopcorn',
  label: '혜택'
}, {
  kind: 'link',
  label: '마이페이지',
  route: ROUTES.MY,
  icon: SvgMyFill
}];
interface LocalMarketBnbProps {
  className?: string;
}
export const LocalMarketBnb = t0 => {
  const $ = _c(43);
  const {
    className
  } = t0;
  const pathname = usePathname();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {};
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const [menuClickAnimated, setMenuClickAnimated] = useState(t1);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      placement: "BOTTOM_NAV_WELMARKET"
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const adpopcorn = useAdpopcorn(t2);
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  if ($[2] !== adpopcorn || $[3] !== className || $[4] !== isDropdownOpen || $[5] !== menuClickAnimated || $[6] !== pathname) {
    let t8;
    if ($[12] !== adpopcorn) {
      t8 = item => item.kind !== "adpopcorn" || !adpopcorn.isExternalWebview;
      $[12] = adpopcorn;
      $[13] = t8;
    } else {
      t8 = $[13];
    }
    const visibleItems = LOCAL_MARKET_BNB_ITEMS.filter(t8);
    let t9;
    if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
      t9 = index => {
        setMenuClickAnimated(prev => ({
          ...prev,
          [index]: true
        }));
        setTimeout(() => {
          setMenuClickAnimated(prev_0 => ({
            ...prev_0,
            [index]: false
          }));
        }, ANIMATION_DURATION);
      };
      $[14] = t9;
    } else {
      t9 = $[14];
    }
    const handleMenuClick = t9;
    t5 = "\uC6F0\uB9C8\uCF19 \uB0B4\uBE44\uAC8C\uC774\uC158";
    if ($[15] !== className) {
      t6 = cn("relative mx-20 flex items-center rounded-pill bg-Gray-white p-8 shadow-[0px_0px_30px_0px_rgba(0,0,0,0.05),0px_16px_50px_0px_rgba(0,0,0,0.05)]", className);
      $[15] = className;
      $[16] = t6;
    } else {
      t6 = $[16];
    }
    let t10;
    if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
      t10 = () => setIsDropdownOpen(_temp);
      $[17] = t10;
    } else {
      t10 = $[17];
    }
    let t11;
    if ($[18] !== isDropdownOpen) {
      t11 = cn("size-20 text-Gray-600 transition-transform duration-200", {
        "rotate-45": isDropdownOpen
      });
      $[18] = isDropdownOpen;
      $[19] = t11;
    } else {
      t11 = $[19];
    }
    let t12;
    if ($[20] !== t11) {
      t12 = <SvgAdd className={t11} />;
      $[20] = t11;
      $[21] = t12;
    } else {
      t12 = $[21];
    }
    let t13;
    if ($[22] !== isDropdownOpen || $[23] !== t12) {
      t13 = <button type="button" className="relative z-50 size-40 rounded-pill bg-Gray-200 duration-150 flex-center hover:scale-110" onClick={t10} aria-label={"\uB2E4\uB978 \uC11C\uBE44\uC2A4\uB85C \uC774\uB3D9"} aria-expanded={isDropdownOpen}>{t12}</button>;
      $[22] = isDropdownOpen;
      $[23] = t12;
      $[24] = t13;
    } else {
      t13 = $[24];
    }
    let t14;
    if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
      t14 = () => setIsDropdownOpen(false);
      $[25] = t14;
    } else {
      t14 = $[25];
    }
    let t15;
    if ($[26] !== isDropdownOpen) {
      t15 = <ServiceSwitchDropdown isOpen={isDropdownOpen} onClose={t14} currentService="market" />;
      $[26] = isDropdownOpen;
      $[27] = t15;
    } else {
      t15 = $[27];
    }
    if ($[28] !== t13 || $[29] !== t15) {
      t7 = <div className="relative z-50">{t13}{t15}</div>;
      $[28] = t13;
      $[29] = t15;
      $[30] = t7;
    } else {
      t7 = $[30];
    }
    t3 = "flex flex-1 items-center justify-around px-12";
    let t16;
    if ($[31] !== adpopcorn || $[32] !== menuClickAnimated || $[33] !== pathname) {
      t16 = (item_0, index_0) => {
        const itemAnimationStyle = {
          animationDuration: `${ANIMATION_DURATION}ms`,
          transitionDelay: `${(index_0 + 1) * 60}ms`,
          transitionProperty: "transform",
          transitionDuration: "300ms"
        } as const;
        if (item_0.kind === "adpopcorn") {
          return <li key={item_0.label} className="w-53"><button type="button" onClick={() => {
              handleMenuClick(index_0);
              adpopcorn.onClick();
            }} disabled={adpopcorn.isOpening} className={cn("flex w-full flex-col items-center duration-150 hover:scale-110 disabled:opacity-60", menuClickAnimated[index_0] && "animate-jump")} style={itemAnimationStyle}><svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" className="size-28"><path d="M14 2.33334C20.4327 2.3335 25.665 7.56632 25.665 13.9994C25.665 20.4324 20.4327 25.6652 14 25.6654C12.326 25.6654 10.6389 25.293 9.12402 24.5882C8.82622 24.4459 8.45627 24.4363 8.07715 24.557L5.09863 25.558C4.8773 25.6309 4.652 25.6663 4.43066 25.6664C3.88383 25.6664 3.35225 25.4512 2.9502 25.0492C2.38318 24.4832 2.1882 23.6608 2.43945 22.9046L3.44531 19.9124C3.56258 19.5451 3.55265 19.1759 3.41504 18.8851C2.70667 17.3618 2.33496 15.6746 2.33496 13.9994C2.335 7.56743 7.56839 2.33334 14 2.33334ZM13.999 8.31674C13.4235 8.31674 12.9062 8.63737 12.6514 9.15073L11.6318 11.2005L9.26855 11.5404C8.71217 11.6206 8.25944 12.0026 8.08594 12.5374C7.91267 13.071 8.05683 13.6445 8.45996 14.0345L10.1631 15.682L9.77539 17.9271C9.67744 18.4918 9.90498 19.0543 10.3691 19.3929C10.8345 19.7327 11.4435 19.7777 11.9531 19.5111L13.9971 18.4447L16.042 19.5121C16.2634 19.6269 16.5021 19.6849 16.7402 19.6849C17.0524 19.6848 17.3614 19.5863 17.627 19.3949C18.091 19.0562 18.3196 18.4961 18.2227 17.929L17.834 15.682L19.5371 14.0345C19.939 13.6445 20.0844 13.071 19.9111 12.5374C19.7388 12.0025 19.2849 11.6205 18.7285 11.5404L16.3652 11.2005L15.3457 9.15073C15.0897 8.63631 14.5732 8.31692 13.999 8.31674Z" fill="#D1D5DD" /></svg><p className="whitespace-nowrap text-center font-500 text-Gray-550 typo-caption2">{item_0.label}</p></button></li>;
        }
        const Icon = item_0.icon;
        const isActive = (() => {
          if (!pathname) {
            return false;
          }
          if (item_0.route.pathname === WEL_MARKET_ROUTES.HOME.pathname) {
            return pathname === item_0.route.pathname;
          }
          return pathname.includes(item_0.route.pathname);
        })();
        return <li key={item_0.label} className="w-53"><CustomLink href={item_0.route.pathname} aria-label={`${item_0.label} 페이지로 이동`} prefetch={true} className={cn("flex w-full flex-col items-center duration-150 hover:scale-110", menuClickAnimated[index_0] && "animate-jump")} style={itemAnimationStyle} onClick={() => handleMenuClick(index_0)}><Icon className={cn("size-28 text-Gray-400", {
              "text-Gray-black": isActive
            })} /><p className={cn("whitespace-nowrap text-center font-500 text-Gray-550 typo-caption2", {
              "font-600 text-Gray-900": isActive
            })}>{item_0.label}</p></CustomLink></li>;
      };
      $[31] = adpopcorn;
      $[32] = menuClickAnimated;
      $[33] = pathname;
      $[34] = t16;
    } else {
      t16 = $[34];
    }
    t4 = visibleItems.map(t16);
    $[2] = adpopcorn;
    $[3] = className;
    $[4] = isDropdownOpen;
    $[5] = menuClickAnimated;
    $[6] = pathname;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
    $[10] = t6;
    $[11] = t7;
  } else {
    t3 = $[7];
    t4 = $[8];
    t5 = $[9];
    t6 = $[10];
    t7 = $[11];
  }
  let t8;
  if ($[35] !== t3 || $[36] !== t4) {
    t8 = <ul className={t3}>{t4}</ul>;
    $[35] = t3;
    $[36] = t4;
    $[37] = t8;
  } else {
    t8 = $[37];
  }
  let t9;
  if ($[38] !== t5 || $[39] !== t6 || $[40] !== t7 || $[41] !== t8) {
    t9 = <nav aria-label={t5} className={t6}>{t7}{t8}</nav>;
    $[38] = t5;
    $[39] = t6;
    $[40] = t7;
    $[41] = t8;
    $[42] = t9;
  } else {
    t9 = $[42];
  }
  return t9;
};
function _temp(prev_1) {
  return !prev_1;
}